import { Mixpanel } from "./mixpanel"
import { PostHog } from "./posthog"
import { gtagEvent } from "./gtag"

export const Analytics = {
	init: () => {
		Mixpanel.init()
		PostHog.init()
	},
	identify: (id: string, properties?: Record<string, unknown>) => {
		Mixpanel.identify(id)
		PostHog.identify(id, properties)
	},
	alias: (id: string) => {
		Mixpanel.alias(id)
		// PostHog doesn't need alias — it handles anonymous-to-identified merging automatically
	},
	capture: (event: string, properties?: Record<string, unknown>) => {
		Mixpanel.track(event, properties)
		PostHog.capture(event, properties)
		gtagEvent(event, properties)
	},
	setPersonProperties: (props: Record<string, unknown>) => {
		Mixpanel.people.set(props)
		PostHog.setPersonProperties(props)
	},
	reset: () => {
		Mixpanel.reset()
		PostHog.reset()
	},
	shutdown: () => {
		PostHog.shutdown()
	},
}
